import React, { useState } from 'react';
import { ShieldCheck, Lock, AlertCircle, X, KeyRound } from 'lucide-react';
import { Modal } from './ui/Modal';
import { toast } from 'sonner';

interface F4PasskeyModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const F4PasskeyModal: React.FC<F4PasskeyModalProps> = ({ open, onClose, onSuccess }) => {
  const [pin, setPin] = useState('');
  const [erro, setErro] = useState(false);

  function handleVerify(e: React.FormEvent) {
    e.preventDefault();
    if (pin.trim() === '159357') {
      toast.success('🔒 Passkey Autorizada com Sucesso!');
      sessionStorage.setItem('f4_passkey_granted', 'true');
      setPin('');
      setErro(false);
      onSuccess();
    } else {
      setErro(true);
      toast.error('Passkey Incorreta! Digite o PIN "159357" para liberar.');
    }
  }

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose} title="" size="default">
      <div style={{
        background: 'linear-gradient(135deg, #1e1b4b 0%, #0f172a 100%)',
        borderRadius: '12px 12px 0 0', padding: '20px 24px', position: 'relative',
        borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', gap: 12
      }}>
        <div style={{
          width: 40, height: 40, borderRadius: '50%', background: 'rgba(129, 140, 248, 0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#818cf8', border: '1px solid rgba(129, 140, 248, 0.4)'
        }}>
          <ShieldCheck size={22} />
        </div>
        <div>
          <h3 style={{ color: '#fff', fontSize: '1rem', fontWeight: 800, margin: 0 }}>
            Autenticação Passkey F4 (Acesso Seguro)
          </h3>
          <p style={{ color: '#94a3b8', fontSize: '0.72rem', margin: '2px 0 0' }}>
            Confirme sua chave de segurança para autorizar o relatório de diagnósticos.
          </p>
        </div>
      </div>

      <form onSubmit={handleVerify} style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{
          background: '#f8fafc', padding: 14, borderRadius: 10, border: '1px solid var(--border-color)',
          display: 'flex', alignItems: 'center', gap: 10
        }}>
          <KeyRound size={18} style={{ color: '#7c3aed', flexShrink: 0 }} />
          <span style={{ fontSize: '0.74rem', color: 'var(--text-main)', lineHeight: 1.4 }}>
            Digite a chave Passkey autorizada do operador para liberar o coletor de telemetria e o gravador de mídia.
          </span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <label className="form-label">PIN Passkey de Segurança</label>
          <input
            type="password"
            autoFocus
            maxLength={6}
            placeholder="Digite PIN 159357..."
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            className="form-input"
            style={{
              fontSize: '1.2rem', textAlign: 'center', letterSpacing: 8, fontWeight: 800,
              borderColor: erro ? '#ef4444' : undefined, background: erro ? '#fef2f2' : undefined
            }}
          />
          {erro && (
            <span style={{ fontSize: '0.7rem', color: '#ef4444', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 4 }}>
              <AlertCircle size={12} /> Passkey incorreta. Dica: PIN "159357".
            </span>
          )}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '8px 16px', borderRadius: 8, border: '1px solid var(--border-color)',
              background: '#fff', color: 'var(--text-main)', fontWeight: 700, fontSize: '0.76rem', cursor: 'pointer'
            }}
          >
            Cancelar
          </button>

          <button
            type="submit"
            style={{
              padding: '8px 20px', borderRadius: 8, border: 'none', background: '#7c3aed',
              color: 'white', fontWeight: 700, fontSize: '0.78rem', cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 6
            }}
          >
            <Lock size={14} /> Autorizar F4
          </button>
        </div>
      </form>
    </Modal>
  );
};
